import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader } from 'lucide-react';

const SpotifyCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  
  // Get correct backend URL - use window.location.origin for production
  const API_URL = window.location.origin;

  useEffect(() => {
    const handleCallback = async () => {
      // Get authorization code from URL
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const errorParam = urlParams.get('error');

      console.log('🎵 SpotifyCallback mounted');
      console.log('🎵 Full URL:', window.location.href);
      console.log('🎵 Code:', code);
      console.log('🎵 Error param:', errorParam);
      console.log('🎵 API_URL:', API_URL);

      if (errorParam) {
        console.error('🎵 Authorization error from Spotify:', errorParam);
        setError('Authorization failed. Please try again.');
        setTimeout(() => navigate('/dashboard-re'), 3000);
        return;
      }

      if (!code) {
        console.error('🎵 No authorization code found in URL');
        setError('No authorization code found.');
        setTimeout(() => navigate('/dashboard-re'), 3000);
        return;
      }

      try {
        // Exchange code for tokens
        const callbackUrl = `${API_URL}/api/spotify/auth/callback?code=${encodeURIComponent(code)}`;
        console.log('🎵 Calling callback URL:', callbackUrl);
        
        const response = await fetch(callbackUrl);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Callback response not OK:', response.status, errorText);
          throw new Error(`Failed to authenticate: ${response.status}`);
        }

        const data = await response.json();
        console.log('🎵 Callback success, storing tokens');
        
        // Store tokens and expiry time
        localStorage.setItem('spotify_access_token', data.access_token);
        localStorage.setItem('spotify_refresh_token', data.refresh_token);
        // Store expiry time (typically 1 hour = 3600 seconds)
        const expiresAt = Date.now() + ((data.expires_in || 3600) * 1000);
        localStorage.setItem('spotify_token_expires', expiresAt.toString());
        
        console.log('🎵 Redirecting to dashboard');
        
        // If opened in a popup, close it and let the opener handle the redirect
        if (window.opener) {
          // Use specific origin instead of wildcard for security
          const targetOrigin = window.location.origin;
          window.opener.postMessage({ type: 'SPOTIFY_AUTH_SUCCESS' }, targetOrigin);
          window.close();
        } else {
          // Redirect to dashboard if not in popup
          navigate('/dashboard-re');
        }
      } catch (err) {
        console.error('Callback error:', err);
        setError(`Authentication failed: ${err.message}. Please try again.`);
        
        // If in popup, close after delay
        if (window.opener) {
          setTimeout(() => window.close(), 3000);
        } else {
          setTimeout(() => navigate('/dashboard-re'), 5000);
        }
      }
    };

    handleCallback();
  }, [navigate, API_URL]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center space-y-4">
        {error ? (
          <>
            <div className="text-red-500 text-xl">❌</div>
            <p className="text-white">{error}</p>
            <p className="text-white/60 text-sm">Redirecting to dashboard...</p>
          </>
        ) : (
          <>
            <Loader size={48} className="text-green-500 animate-spin mx-auto" />
            <p className="text-white text-lg">Connecting to Spotify...</p>
            <p className="text-white/60 text-sm">Please wait</p>
          </>
        )}
      </div>
    </div>
  );
};

export default SpotifyCallback;
